import { create } from 'zustand';

export type PaletteMode = 'commands' | 'search';

/** Command palette session state (open/closed and which mode it opened in). */
export interface PaletteStore {
  readonly open: boolean;
  readonly mode: PaletteMode;
  readonly show: (mode?: PaletteMode) => void;
  readonly hide: () => void;
}

export const usePaletteStore = create<PaletteStore>()((set) => ({
  open: false,
  mode: 'commands',
  show: (mode = 'commands') => {
    set({ open: true, mode });
  },
  hide: () => {
    set({ open: false });
  },
}));
